
export const numtiersCible = (rootGetters) => {
  const numtiersSelectionne = rootGetters['adherent/numtiers']
  if (numtiersSelectionne != null) {
    return numtiersSelectionne
  }

  return rootGetters['user/profil']?.username
}

export default numtiersCible
